import styled from "styled-components";

import {
	FONT_WT_LIGHT,
	COLOR_WHITE,
	COLOR_BORDER_LIGHT_GREY,
	COLOR_TEXT_HIGHLIGHT,
	COLOR_LIGHT_GREEN,
	COLOR_NOBEL_GREY,
	COLOR_TEXT_PRIMARY_B2C,
} from "@website-builder/utilities-index";

export const SelectWrapper = styled.div`
	position: relative;
	border: ${(props) =>
		props.showAllOptions
			? `1px solid ${COLOR_BORDER_LIGHT_GREY}`
			: `1px solid ${COLOR_WHITE}`};
	width: 100%;
	z-index: 1;
`;

export const Option = styled.div`
	display: flex;
	align-items: center;
	padding: 6px 20px 6px 20px;
	cursor: pointer;

	font-weight: ${FONT_WT_LIGHT};
	font-size: 18px;
	line-height: 21px;

	color: ${COLOR_TEXT_PRIMARY_B2C};

	background: ${(props) =>
		props.isSelected ? `${COLOR_LIGHT_GREEN}` : `${COLOR_WHITE}`};
	box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.05);
	border-radius: 3px;
	min-width: 230px;

	&.option-title {
		border: ${(props) =>
			props.showAllOptions ? "none" : `1px solid ${COLOR_BORDER_LIGHT_GREY}`};
		padding-bottom: 15px;
	}
	&.optionIcon {
		margin-right: 5px;
		width: 22px;
	}
	.optionLabel {
		line-height: 22px;
		padding-top: 10px;
		display: inline-block;
	}

	.caretIcon {
		img {
			height: 15px;
			transition: transform 0.5s ease-in-out;
			transform: ${(props) =>
				props.showAllOptions ? "rotateX(180deg)" : "none"};
		}
		margin-left: auto;
		margin-top: auto;
	}
`;

export const CheckBox = styled.span`
	/* Customize the label (the container) */
	.container {
		display: block;
		position: relative;
		padding-left: 25px;
		margin-bottom: 10px;
		cursor: pointer;
		font-size: 18px;
		line-height: 21px;

		color: ${COLOR_TEXT_PRIMARY_B2C};
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	/* Hide the browser's default checkbox */
	.container input {
		position: absolute;
		opacity: 0;
		cursor: pointer;
		height: 0;
		width: 0;
	}

	/* Create a custom checkbox */
	.checkmark {
		position: absolute;
		top: 0;
		left: 0;
		height: 16px;
		width: 16px;
		margin-right: 8px;
		margin-top: 3px;
		background-color: #eee;
		border: 1px solid ${COLOR_NOBEL_GREY};
		box-sizing: border-box;
	}

	/* On mouse-over, add a grey background color */
	.container:hover input ~ .checkmark {
		background-color: #ccc;
	}

	/* When the checkbox is checked, add a blue background */
	.container input:checked ~ .checkmark {
		background-color: ${COLOR_TEXT_HIGHLIGHT};
	}

	/* Create the checkmark/indicator (hidden when not checked) */
	.checkmark:after {
		content: "";
		position: absolute;
		display: none;
	}

	/* Show the checkmark when checked */
	.container input:checked ~ .checkmark:after {
		display: block;
	}

	/* Style the checkmark/indicator */
	.container .checkmark:after {
		left: 5px;
		top: 2px;
		width: 3px;
		height: 7px;
		border: solid white;
		border-width: 0 2px 2px 0;
		-webkit-transform: rotate(45deg);
		-ms-transform: rotate(45deg);
		transform: rotate(45deg);
	}
`;
